module.exports = __webpack_public_path__ + "img/rank4.df20fca3.png";